<template>
  <div>
    <div class="wapper">
      <div class="wapper-content text-center">
        <img class="logo" :src="logo" />
        <p class="text-title">hpoto</p>
        <p class="text-content">专注当下，每分每秒都值得认真对待。</p>
        <div>
          <a
            title="微信"
            href="javascript:void(0)"
            @mouseover="toggleWechat(true)"
            @mouseout="toggleWechat(false)"
          >
            <span class="icon iconfont">&#xe600;</span>
          </a>
          <a title="邮箱" href="mailto:hpoto@live.cn">
            <span class="icon iconfont">&#xe62d;</span>
          </a>
          <a title="github" target="_blank" href="https://github.com/hpoto">
            <span class="icon iconfont">&#xe689;</span>
          </a>
          <!--
          <a title="dify" target="_blank" href="https://home.hpoto.cn:8443/signin">
            <span class="icon iconfont">&#xe603;</span>
          </a>
          -->
          <a title="堡垒机" target="_blank" href="https://jump.xzstardata.cn:8443">
            <span class="icon iconfont">&#xe76c;</span>
          </a>
          <a title="存储" target="_blank" href="https://home.hpoto.cn:3003">
            <span class="icon iconfont">&#xe69a;</span>
          </a>
          <a title="WebShark" target="_blank" href="https://home.hpoto.cn:3004">
            <span class="icon iconfont">&#xe821;</span>
          </a>
        </div>
        <img v-if="wechat.show" class="wechat" :src="wechat.img" />
      </div>
    </div>
    <div class="footer" role="footer">
      <a
        target="_blank"
        href="https://beian.miit.gov.cn"
        rel="noopener noreferrer"
        title="苏ICP备16021154号-2"
        >苏ICP备16021154号-2</a
      >
    </div>
  </div>
</template>
<script>
import logoImg from "@/assets/img/logo.png";
import wechatImg from "@/assets/img/wechat.jpg";
export default {
  name: "Home",
  data() {
    return {
      wechat: {
        show: false,
        img: wechatImg,
      },
      logo: logoImg,
    };
  },
  methods: {
    toggleWechat(bool) {
      this.wechat.show = bool;
    },
  },
};
</script>
<style lang="less" scoped>
@import url(~@/assets/iconfont/iconfont.css);
.wapper {
  height: 100vh;
  background: linear-gradient(to right, #337ab7 0%, #fcf8e3 100%);
  .wapper-content {
    position: absolute;
    min-width: 315px;
    height: 400px;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    .text-title {
      font-size: 2.5rem;
    }
    .text-content {
      font-size: 1.5rem;
    }
    .logo {
      width: 10rem;
      margin-top: 0.1rem;
    }
    a {
      margin: 0 0.2rem;
      color: #007bff;
      text-decoration: none;
      .icon {
        font-size: 1.5rem;
      }
    }
    .wechat {
      width: 10rem;
      margin-top: 0.1rem;
    }
  }
  #content {
    display: none;
  }
}
.footer {
  position: fixed;
  bottom: 0px;
  width: 100%;
  text-align: center;
  a {
    text-decoration: none;
    color: #333;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -moz-user-focus: none;
  }
}
</style>
